import { render, staticRenderFns } from "./ProfileGeneral.vue?vue&type=template&id=78f261ab"
import script from "./ProfileGeneral.vue?vue&type=script&lang=js"
export * from "./ProfileGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports